import { OutputScale } from '../../../../../utils/OutputScale';

/**
 * Taken from pdf.js/web/pdf_thumbnail_view.js #getPageDrawContext
 */
export const getOutlineImageCanvasContext = ({
  upscaleFactor,
  width,
  height,
  enableHMA,
}: {
  upscaleFactor: number;
  width: number;
  height: number;
  enableHMA: boolean;
}) => {
  const canvas = document.createElement('canvas');

  const ctx = canvas.getContext('2d', {
    alpha: false,
    willReadFrequently: !enableHMA,
  });
  const outputScale = new OutputScale();

  canvas.width = (upscaleFactor * width * outputScale.sx) | 0;
  canvas.height = (upscaleFactor * height * outputScale.sy) | 0;

  const transform = outputScale.scaled ? [outputScale.sx, 0, 0, outputScale.sy, 0, 0] : undefined;

  return { canvas, ctx, transform };
};
